/* eslint-disable jsx-a11y/anchor-is-valid */
import {FC} from 'react'
import {PageLink, PageTitle} from '../../../_metronic/layout/core'
import {ClassifiedCategoriesListWrapper} from '../../modules/classified-module/categories/ClassifiedCategoriesList'

const ClassifiedCategoriesPage: FC = () => {
  const breadcrum: Array<PageLink> = [
    {
      title: 'Classified Module',
      path: '/classified-module',
      isSeparator: false,
      isActive: false,
    },
    {
      title: '',
      path: '',
      isSeparator: true,
      isActive: false,
    },
  ]
  return (
    <>
      <PageTitle breadcrumbs={breadcrum}>Categories</PageTitle>
      <ClassifiedCategoriesListWrapper />
    </>
  )
}

export {ClassifiedCategoriesPage}
